export enum EditableTableActions {
	TABLE_ROW_ACTION = 'SelectRowAction',
}
